module.exports = __webpack_public_path__ + "img/series_01.aba9c718.png";